const targetNodes = document.querySelectorAll(".Form__Element__ValidationError");
const config = { attributes: false, childList: true, subtree: true };

function decodeHtml(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return htmlsanitizer.SanitizeHtml(txt.value);
}

const callback = function (mutationsList) {
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            const html = mutation.target.innerHTML;
            if (html.indexOf("&lt;") !== -1) {
                mutation.target.innerHTML = htmlsanitizer.SanitizeHtml(decodeHtml(html));
            }
        }
    }
};
const observer = new MutationObserver(callback);
targetNodes.forEach(function (targetNode) {
    observer.observe(targetNode, config);
});

